const LoginConfigData = ({ email } = {}) => ({
  email: email || "",
  password: ""
});

export default LoginConfigData;
